import * as React from 'react';
import Field from '../Field/Field';
import { BaseButton } from '../../BaseComponents';
import { Form } from 'react-final-form';
import { useTheme } from '../../theme';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../context';
import { removeTrailingSlash } from '../../utils';
import { useRetrieveBookingValidation } from '../../RetrieveBooking/hooks';

const Booking: React.FC = () => {
	const engineURL = useConfig().SearchForm.engineURL;

	const { t } = useTranslation('Forms');

	const theme = useTheme('Forms').Booking;

	const {
		ticketNumberValidation,
		validateByOrderNumber,
		requiredValidation,
		requiredValidationWrapper
	} = useRetrieveBookingValidation();

	const onOrderNumberValidation = (value: string) => {
		const ticketNumberError = ticketNumberValidation(value);
		const orderNumberError = validateByOrderNumber(value);

		if (!ticketNumberError || !orderNumberError) {
			return undefined;
		}

		return ticketNumberError || orderNumberError;
	};

	const onSubmit = (values: any) => {
		window.location.href = `${removeTrailingSlash(engineURL)}/#/find/${values['orderNumber']}/${
			values['lastName']
		}/Submit`;
	};

	return (
		<Form
			onSubmit={onSubmit}
			initialValues={{
				orderNumber: '',
				lastName: ''
			}}
		>
			{({ handleSubmit }) => (
				<div className={theme.container}>
					<form onSubmit={handleSubmit} className={theme.inner}>
						<Field
							name="orderNumber"
							label={t('Order number')}
							validation={requiredValidationWrapper(onOrderNumberValidation)}
						/>

						<Field name="lastName" label={t('Last name')} validation={requiredValidation} />

						<BaseButton type="submit" variant="smallPrimary" size="large" className={theme.submit}>
							{t('Find')}
						</BaseButton>
					</form>
				</div>
			)}
		</Form>
	);
};

export default Booking;
